import { render, staticRenderFns } from "./ShipOrder.vue?vue&type=template&id=27b87b5a&scoped=true"
import script from "./ShipOrder.vue?vue&type=script&lang=js"
export * from "./ShipOrder.vue?vue&type=script&lang=js"
import style0 from "./ShipOrder.vue?vue&type=style&index=0&id=27b87b5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b87b5a",
  null
  
)

export default component.exports